module.exports = __webpack_public_path__ + "img/Feature.209c4abf.png";